export type ActivityEntryHeaderContext = {
  templateName: string;
  departmentName: string;
  reportTagName?: string | null;
  reportTagStatusLabel?: string | null;
  reportTagSince?: string | null;
  reportTagUntil?: string | null;
  reportTagDeadline?: string | null;
  tagIsOpen?: boolean;
  activityStatusName?: string | null;
  activityStatusLabel: string;
  activityStatusVariant: string;
  parentDepartmentStatusLabel: string;
  parentDepartmentStatusVariant: string;
  periodRangeText: string;
  accessLabel: string;
  editabilityText: string;
  needsAttentionReason?: string | null;
};

export function areActivityEntryHeaderContextsEqual(
  a: ActivityEntryHeaderContext | null,
  b: ActivityEntryHeaderContext | null
): boolean {
  if (a === b) return true;
  if (a == null || b == null) return false;
  return (
    a.templateName === b.templateName &&
    a.departmentName === b.departmentName &&
    (a.reportTagName ?? null) === (b.reportTagName ?? null) &&
    (a.reportTagStatusLabel ?? null) === (b.reportTagStatusLabel ?? null) &&
    (a.reportTagSince ?? null) === (b.reportTagSince ?? null) &&
    (a.reportTagUntil ?? null) === (b.reportTagUntil ?? null) &&
    (a.reportTagDeadline ?? null) === (b.reportTagDeadline ?? null) &&
    (a.tagIsOpen ?? true) === (b.tagIsOpen ?? true) &&
    (a.activityStatusName ?? null) === (b.activityStatusName ?? null) &&
    a.activityStatusLabel === b.activityStatusLabel &&
    a.activityStatusVariant === b.activityStatusVariant &&
    a.parentDepartmentStatusLabel === b.parentDepartmentStatusLabel &&
    a.parentDepartmentStatusVariant === b.parentDepartmentStatusVariant &&
    a.periodRangeText === b.periodRangeText &&
    a.accessLabel === b.accessLabel &&
    a.editabilityText === b.editabilityText &&
    (a.needsAttentionReason ?? null) === (b.needsAttentionReason ?? null)
  );
}
